"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Dropdown = require("./Dropdown.provider");

var _icons = require("../../assets/icons");

var _DropdownMenuItem = require("./DropdownMenuItem.styles");

var _util = require("../../util");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Item = (0, _base["default"])("li", {
  target: "e1dk3t1i0",
  label: "Item"
})(_DropdownMenuItem.styles.base, ";");

var DropdownMenuItem = function DropdownMenuItem(_ref) {
  var className = _ref.className,
      children = _ref.children,
      highlight = _ref.highlight,
      itemKey = _ref.itemKey,
      item = _ref.item,
      as = _ref.as,
      onClick = _ref.onClick,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["className", "children", "highlight", "itemKey", "item", "as", "onClick"]);

  var _useContext = (0, _react.useContext)(_Dropdown.DropdownContext),
      negativeHover = _useContext.negativeHover,
      onSelect = _useContext.onSelect,
      setOpen = _useContext.setOpen;

  var handleSelect = (0, _react.useCallback)(function (e) {
    if (typeof onSelect === 'function') {
      onSelect(itemKey, item);
    }

    onClick(e, itemKey, item);
    setOpen(false);
  }, [onSelect, onClick, itemKey, item, setOpen]);
  var handleKeyDown = (0, _react.useCallback)(function (e) {
    (0, _util.handleEnter)(e, handleSelect);
  }, [handleSelect]);
  return (0, _jsxRuntime.jsxs)(Item, _objectSpread(_objectSpread({
    as: as,
    tabIndex: 0,
    role: "menuitem",
    css: [negativeHover && _DropdownMenuItem.styles.negativeHover, highlight && _DropdownMenuItem.styles.highlight, process.env.NODE_ENV === "production" ? "" : ";label:DropdownMenuItem;"],
    className: className,
    onClick: handleSelect,
    onKeyDown: handleKeyDown
  }, otherProps), {}, {
    children: [children, (0, _jsxRuntime.jsx)("span", {
      css: _DropdownMenuItem.styles.icon,
      children: (0, _jsxRuntime.jsx)(_icons.Enter, {})
    })]
  }));
};

DropdownMenuItem.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]).isRequired,
  className: _propTypes.string,

  /**
   * Whether to add light-grey background and black-medium font
   */
  highlight: _propTypes.bool,

  /**
   * itemKey will pass to onSelect function
   */
  itemKey: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired,

  /**
   * item will passed to onSelect function
   */
  item: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.bool, _propTypes.number, _propTypes.object]),

  /**
   * Change 'as' when want to use link for menu item,
   * that will make the arrow item be a part of link too,
   * otherwise click the arrow will not trigger redirect
   */
  as: _propTypes.elementType,
  onClick: _propTypes.func
};
DropdownMenuItem.defaultProps = {
  className: undefined,
  highlight: false,
  item: undefined,
  as: 'li',
  onClick: function onClick() {}
};
var _default = DropdownMenuItem;
exports["default"] = _default;
//# sourceMappingURL=DropdownMenuItem.js.map